export default "__VITE_ASSET__DxekY1oH__"